import { ScrollText } from 'lucide-react'
import { useParams } from 'react-router-dom'
import {
  Badge, Card, CardHeader, EmptyState, ErrorState, LoadingState, PageHeader,
  Table, TableBody, TableCell, TableEmpty, TableHead, TableHeader, TableRow, useResource,
} from '@retink/web-ui'
import { api } from '../../lib/api'

interface Activity {
  id: string
  occurred_at: string
  action: string
  actor_type: string
  actor_email: string | null
  target_type: string | null
  target_id: string | null
}

export function OrgActivity() {
  const { orgId } = useParams<{ orgId: string }>()
  const { data: entries = [], loading, error, reload } = useResource(
    () => api.get<Activity[]>(`/api/orgs/${orgId}/activity`),
    [orgId],
  )
  return (
    <div className="p-8">
      <PageHeader title="Activity" description="Recent organization, identity, people, and workspace changes." />
      <Card className="overflow-hidden">
        <CardHeader>Events</CardHeader>
        <Table>
          <TableHeader><TableRow>{['When', 'Action', 'Actor', 'Target'].map((label) => <TableHead key={label}>{label}</TableHead>)}</TableRow></TableHeader>
          <TableBody>
            {loading && <TableEmpty colSpan={4}><LoadingState /></TableEmpty>}
            {!loading && error && <TableEmpty colSpan={4}><ErrorState message={error} onRetry={reload} /></TableEmpty>}
            {!loading && !error && entries.length === 0 && (
              <TableEmpty colSpan={4}><EmptyState icon={ScrollText} title="No activity yet" description="Organization changes will appear here." /></TableEmpty>
            )}
            {entries.map((entry) => (
              <TableRow key={entry.id}>
                <TableCell className="whitespace-nowrap text-xs text-muted-foreground">{new Date(entry.occurred_at).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-xs">{entry.action}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{entry.actor_email ?? <Badge tone="neutral">{entry.actor_type}</Badge>}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{entry.target_type ?? '—'} {entry.target_id && <span className="font-mono">{entry.target_id}</span>}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  )
}
